import { useEffect, useRef, useState } from 'react';

const style = `
/* Fonts are loaded via HTML head to avoid CSP issues */
* { margin: 0; padding: 0; box-sizing: border-box; }
body { font-family: var(--font-inter, 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif); background-color: #f8f9fa; height: 100vh; overflow: hidden; }
.container { display: flex; height: 100vh; }
/* Sidebar Styles */
.sidebar { width: 250px; border-right: 1px solid rgb(210, 213, 220); display: flex; flex-direction: column; padding: 20px 0; }
.sidebar-header { display: flex; align-items: center; padding: 0 20px 20px; gap: 12px; }
.hamburger { width: 20px; height: 20px; cursor: pointer; }
.logo { font-size: 18px; font-weight: 600; color: #0066ff; }
.write-message-btn { margin: 0 20px 30px; background: #f8f9fa; border: 1px solid rgb(210, 213, 220); border-radius: 8px; padding: 12px 16px; display: flex; align-items: center; gap: 8px; cursor: pointer; font-size: 14px; color: #495057; }
.write-message-btn:hover { background: rgb(210, 213, 220); }
.nav-section { padding: 0px !important; margin-bottom: 30px; }
.nav-item { display: flex; align-items: center; padding: 8px 0; cursor: pointer; border-radius: 6px; margin-bottom: 4px; position: relative; }
.nav-item:hover { background: #f8f9fa; }
.nav-item.active { background: #e3f2fd; color: #0066ff; }
.nav-item .icon { width: 20px; height: 20px; margin-right: 12px; }
.nav-item .badge { background: #dc3545; color: white; border-radius: 12px; padding: 2px 8px; font-size: 12px; margin-left: auto; }
.section-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; font-size: 12px; color: #6c757d; text-transform: uppercase; font-weight: 600; }
.collapse-arrow { width: 12px; height: 12px; cursor: pointer; }
.category-item { display: flex; align-items: center; padding: 6px 0; cursor: pointer; margin-bottom: 4px; }
.category-item:hover { background: #f8f9fa; border-radius: 4px; }
.category-dot { width: 8px; height: 8px; border-radius: 50%; margin-right: 12px; background: #a855f7; }
.category-count { margin-left: auto; font-size: 12px; color: #6c757d; }
.chat-item { display: flex; align-items: center; padding: 8px 0; cursor: pointer; border-radius: 6px; margin-bottom: 4px; position: relative; }
.chat-item:hover { background: #f8f9fa; }
.chat-avatar { width: 32px; height: 32px; border-radius: 50%; margin-right: 12px; position: relative; }
.online-dot { position: absolute; bottom: 0; right: 0; width: 8px; height: 8px; background: #10b981; border: 2px solid white; border-radius: 50%; }
.chat-badge { background: #dc3545; color: white; border-radius: 10px; padding: 2px 6px; font-size: 11px; margin-left: auto; }
.start-chat { color: #0066ff; font-weight: 500; }
/* Main Content */
.main-content { flex: 1; display: flex; flex-direction: column; background: white; }
/* Top Header */
.top-header { display: flex; align-items: center; padding: 16px 24px; border-bottom: 1px solid rgb(210, 213, 220); gap: 20px; }
.search-container { flex: 1; max-width: 400px; position: relative; }
.search-input { width: 100%; padding: 10px 40px 10px 16px; border: 1px solid rgb(210, 213, 220); border-radius: 8px; background: #f8f9fa; font-size: 14px; }
.search-input::placeholder { color: #6c757d; }
.search-dropdown { position: absolute; right: 12px; top: 50%; transform: translateY(-50%); width: 16px; height: 16px; cursor: pointer; }
.header-actions { display: flex; align-items: center; gap: 16px; }
.notification-btn { position: relative; width: 32px; height: 32px; border: none; background: none; cursor: pointer; border-radius: 6px; }
.notification-btn:hover { background: #f8f9fa; }
.user-avatar { width: 32px; height: 32px; border-radius: 50%; background: #dc3545; color: white; display: flex; align-items: center; justify-content: center; font-weight: 600; cursor: pointer; }
/* Filter Bar */
.filter-bar { display: flex; align-items: center; justify-content: space-between; padding: 16px 24px; border-bottom: 1px solid rgb(210, 213, 220); }
.filter-left { display: flex; align-items: center; gap: 16px; }
.primary-filter { display: flex; align-items: center; gap: 8px; padding: 8px 12px; border: 1px solid rgb(210, 213, 220); border-radius: 6px; background: white; cursor: pointer; }
.filter-center { display: flex; align-items: center; gap: 16px; }
.undo-btn { width: 32px; height: 32px; border: 1px solid rgb(210, 213, 220); background: white; border-radius: 6px; cursor: pointer; display: flex; align-items: center; justify-content: center; }
.timestamp { font-size: 14px; color: #6c757d; }
.filter-right { display: flex; align-items: center; gap: 12px; }
.add-widget { color: #0066ff; font-size: 14px; font-weight: 500; cursor: pointer; }
/* Content Area */
.content-area { flex: 1; display: grid; grid-template-columns: 350px 1fr 300px; overflow: hidden; }
/* Email List */
.email-list { border-right: 1px solid rgb(210, 213, 220); overflow-y: auto; }
.email-item { display: flex; align-items: flex-start; padding: 16px 20px; border-bottom: 1px solid #f8f9fa; cursor: pointer; gap: 12px; }
.email-item:hover { background: #d4e9fc69; }
.email-item.selected { background: #e3f2fd; }
.email-avatar { width: 40px; height: 40px; border-radius: 50%; background: #dc3545; color: white; display: flex; align-items: center; justify-content: center; font-weight: 600; flex-shrink: 0; }
.email-content { flex: 1; min-width: 0; }
.email-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 4px; }
.sender-name { font-weight: 600; color: #212529; }
.email-time { font-size: 12px; color: #6c757d; }
.email-subject { font-weight: 600; color: #212529; margin-bottom: 4px; }
.email-preview { color: #6c757d; font-size: 14px; line-height: 1.4; }
.attachment-icon { width: 16px; height: 16px; margin-top: 4px; }
/* Email Detail */
.email-detail { padding: 24px; border-right: 1px solid rgb(210, 213, 220); overflow-y: auto; position: relative; }
.email-detail-header { display: flex; align-items: center; gap: 12px; margin-bottom: 24px; }
.detail-avatar { width: 50px; height: 50px; border-radius: 50%; background: #dc3545; color: white; display: flex; align-items: center; justify-content: center; font-weight: 600; }
.sender-info h3 { font-weight: 600; color: #212529; margin-bottom: 2px; }
sender-info p { color: #6c757d; font-size: 14px; }
.email-subject-detail { font-size: 24px; font-weight: 600; color: #212529; margin-bottom: 24px; line-height: 1.3; }
.email-body { color: #495057; line-height: 1.6; margin-bottom: 32px; }
.email-body p { margin-bottom: 16px; }
.attachments { display: flex; gap: 12px; margin-bottom: 32px; }
.attachment-btn { display: flex; align-items: center; gap: 8px; padding: 12px 16px; border: 1px solid rgb(210, 213, 220); border-radius: 8px; background: rgba(196, 219, 255, 0.15); cursor: pointer; text-decoration: none; color: #495057; }
.attachment-btn:hover { background: rgba(196, 219, 255, 0.25); }
.attachment-info { display: flex; flex-direction: column; }
.attachment-name { font-weight: 500; font-size: 14px; }
.attachment-size { font-size: 12px; color: #6c757d; }
.dropdown-menu { position: absolute; top: 80px; right: 24px; background: white; border: 1px solid rgb(210, 213, 220); border-radius: 8px; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); padding: 8px 0; min-width: 200px; z-index: 10; display: none; }
.dropdown-item { display: flex; align-items: center; gap: 12px; padding: 8px 16px; cursor: pointer; font-size: 14px; color: #495057; }
.dropdown-item:hover { background: #f8f9fa; }
.reply-section { border-top: 1px solid rgb(210, 213, 220); padding-top: 24px; }
.reply-header { display: flex; align-items: center; gap: 12px; margin-bottom: 16px; }
.reply-avatar { width: 32px; height: 32px; border-radius: 50%; background: #dc3545; color: white; display: flex; align-items: center; justify-content: center; font-weight: 600; }
.reply-text { color: #495057; line-height: 1.5; margin-bottom: 24px; }
.reply-actions { display: flex; align-items: center; gap: 16px; }
.send-btn { background: #0066ff; color: white; border: none; padding: 10px 20px; border-radius: 6px; font-weight: 500; cursor: pointer; }
.send-btn:hover { background: #0052cc; }
.reply-tools { display: flex; align-items: center; gap: 12px; }
.tool-icon { width: 20px; height: 20px; cursor: pointer; opacity: 0.6; }
.tool-icon:hover { opacity: 1; }
/* Right Sidebar */
.right-sidebar { padding: 24px; overflow-y: auto; }
.sidebar-section { margin-bottom: 32px; }
.sidebar-section h3 { font-weight: 600; color: #212529; margin-bottom: 16px; }
.photos-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
.photo-placeholder { width: 100%; height: 80px; background: #dc3545; border-radius: 8px; }
.files-list { display: flex; flex-direction: column; gap: 12px; }
.file-item { display: flex; align-items: center; gap: 12px; padding: 12px; border: 1px solid rgb(210, 213, 220); border-radius: 8px; cursor: pointer; }
.file-item:hover { background: #f8f9fa; }
.file-icon { width: 32px; height: 32px; border-radius: 6px; display: flex; align-items: center; justify-content: center; color: white; font-weight: 600; font-size: 12px; }
.file-icon.blue { background: #0066ff; }
.file-icon.yellow { background: #ffc107; }
.file-icon.green { background: #28a745; }
.file-info { flex: 1; }
.file-name { font-weight: 500; color: #212529; margin-bottom: 2px; }
.file-size { font-size: 12px; color: #6c757d; }
@media (max-width: 1200px) { .content-area { grid-template-columns: 300px 1fr 250px; } }
@media (max-width: 768px) { .sidebar { position: absolute; left: -250px; z-index: 1000; transition: left 0.3s ease; } .sidebar.open { left: 0; } .content-area { grid-template-columns: 1fr; } .email-list, .right-sidebar { display: none; } }
`;

export default function ViewEmailStandalone() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownTriggerRef = useRef<HTMLElement>(null);
  const dropdownMenuRef = useRef<HTMLElement>(null);
  // Email selection state
  // const [selectedEmail, setSelectedEmail] = useState(0);
  // Nav selection state
  // const [activeNav, setActiveNav] = useState(0);
  // Category selection state
  // const [activeCategory, setActiveCategory] = useState(0);
  // Chat selection state
  // const [activeChat, setActiveChat] = useState(-1);

  useEffect(() => {
    const styleTag = document.createElement('style');
    styleTag.innerHTML = style;
    document.head.appendChild(styleTag);
    return () => { document.head.removeChild(styleTag); };
  }, []);

  useEffect(() => {
    function handleClick(event: MouseEvent) {
      if (
        dropdownTriggerRef.current &&
        !dropdownTriggerRef.current.contains(event.target as Node) &&
        dropdownMenuRef.current &&
        !dropdownMenuRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false);
      }
    }
    if (dropdownOpen) {
      document.addEventListener('mousedown', handleClick);
    } else {
      document.removeEventListener('mousedown', handleClick);
    }
    return () => document.removeEventListener('mousedown', handleClick);
  }, [dropdownOpen]);

  // Email list data (static for now)
  // const emails = [
  //   {
  //     avatar: 'https://placehold.co/40x40/4285f4/white?text=AS',
  //     sender: 'Artem Sazonov',
  //     subject: 'Codedellaroute Project',
  //     preview: 'Hey Cak, Could you free now? Can you look and read the brief first...',
  //     timestamp: '10:53PM',
  //     hasAttachment: true,
  //   },
  //   {
  //     avatar: 'https://placehold.co/40x40/4285f4/white?text=AS',
  //     sender: 'Artem Sazonov',
  //     subject: 'Codedellaroute Project',
  //     preview: 'Hey Cak, Could you free now? Can you look and read the brief first...',
  //     timestamp: '10:53PM',
  //     hasAttachment: true,
  //   },
  //   {
  //     avatar: 'https://placehold.co/40x40/4285f4/white?text=AS',
  //     sender: 'Artem Sazonov',
  //     subject: 'Codedellaroute Project',
  //     preview: 'Hey Cak, Could you free now? Can you look and read the brief first...',
  //     timestamp: '10:53PM',
  //     hasAttachment: true,
  //   },
  //   {
  //     avatar: 'https://placehold.co/40x40/059669/white?text=JD',
  //     sender: 'John Doe',
  //     subject: 'Meeting Tomorrow',
  //     preview: "Don't forget about our meeting tomorrow at 2 PM...",
  //     timestamp: '9:30AM',
  //     hasAttachment: false,
  //   },
  //   {
  //     avatar: 'https://placehold.co/40x40/dc2626/white?text=SM',
  //     sender: 'Sarah Miller',
  //     subject: 'Budget Review',
  //     preview: 'Please review the attached budget proposal for Q4...',
  //     timestamp: 'Yesterday',
  //     hasAttachment: true,
  //   },
  //   {
  //     avatar: 'https://placehold.co/40x40/7c3aed/white?text=MJ',
  //     sender: 'Mike Johnson',
  //     subject: 'Project Update',
  //     preview: 'The latest updates on the development progress...',
  //     timestamp: 'Yesterday',
  //     hasAttachment: false,
  //   },
  // ];

  // // Nav items
  // const navItems = [
  //   { label: 'Inbox', icon: (
  //     <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
  //       <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
  //       <polyline points="22,6 12,13 2,6" />
  //     </svg>
  //   ), badge: 102 },
  //   { label: 'Starred', icon: (
  //     <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
  //       <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
  //     </svg>
  //   ) },
  //   { label: 'Sent', icon: (
  //     <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
  //       <line x1="22" y1="2" x2="11" y2="13" />
  //       <polygon points="22,2 15,22 11,13 2,9 22,2" />
  //     </svg>
  //   ) },
  //   { label: 'Draft', icon: (
  //     <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
  //       <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
  //       <polyline points="14,2 14,8 20,8" />
  //     </svg>
  //   ) },
  //   { label: 'Spam', icon: (
  //     <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
  //       <path d="M12 2L2 7l10 5 10-5-10-5z" />
  //       <path d="M2 17l10 5 10-5" />
  //       <path d="M2 12l10 5 10-5" />
  //     </svg>
  //   ) },
  //   { label: 'Trash', icon: (
  //     <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
  //       <polyline points="3,6 5,6 21,6" />
  //       <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
  //     </svg>
  //   ) },
  // ];

  // Render the full structure as in the provided HTML, using the above state for interactivity
  return (
    <div className="container">
      {/* Left Sidebar */}
      <div className="left-sidebar">
        <div className="sidebar-header">
          <svg className="hamburger" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
          <div className="logo">qloop.</div>
        </div>
        <div className="write-message-btn">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ marginRight: 8 }}>
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
            <path d="m18.5 2.5 3 3L12 15l-4 1 1-4 9.5-9.5z" />
          </svg>
          Write Message
        </div>
        <div className="nav-section">
          <div className="nav-item active">
            <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
              <polyline points="22,6 12,13 2,6" />
            </svg>
            Inbox
            <span className="badge">102</span>
          </div>
          <div className="nav-item">
            <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
            </svg>
            Starred
          </div>
          <div className="nav-item">
            <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="22" y1="2" x2="11" y2="13" />
              <polygon points="22,2 15,22 11,13 2,9 22,2" />
            </svg>
            Sent
          </div>
          <div className="nav-item">
            <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14,2 14,8 20,8" />
            </svg>
            Draft
          </div>
          <div className="nav-item">
            <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 2L2 7l10 5 10-5-10-5z" />
              <path d="M2 17l10 5 10-5" />
              <path d="M2 12l10 5 10-5" />
            </svg>
            Spam
          </div>
          <div className="nav-item">
            <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="3,6 5,6 21,6" />
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
            </svg>
            Trash
          </div>
        </div>
        {/* ...continue with the rest of your HTML structure, using className, self-closing tags, and React state for dropdown and selection... */}
      </div>
      {/* ...Middle Pane, Main Content, Right Sidebar, etc. as in your HTML... */}
    </div>
  );
} 